// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605150803/js/" + chunkId + "." + {"44":"6067a178","225":"1e7ab1a3","481":"639ed1fd","486":"137bd578","770":"773f169e"}[chunkId] + ".0.40942023251360915.chunk.js";
};